import React from "react";

export interface AccountType {
  id: string;
  label: string;
  description: string;
  icon: React.ReactNode;
}

export const accountTypes = [
  {
    id: "buyer",
    label: "Buyer",
    description:
      "I'm looking to rent or buy properties and apartments on Krent.",
    icon: (
      <svg
        width="19"
        height="15"
        viewBox="0 0 19 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.5 7.5C11.433 7.5 13 5.933 13 4C13 2.067 11.433 0.5 9.5 0.5C7.567 0.5 6 2.067 6 4C6 5.933 7.567 7.5 9.5 7.5ZM9.5 9.5C5.91 9.5 0.5 11.17 0.5 13.75V14.75H18.5V13.75C18.5 11.17 13.09 9.5 9.5 9.5Z"
          fill="#056C57"
        />
      </svg>
    ),
  },
  {
    id: "seller",
    label: "Seller",
    description:
      "I'm looking to sell properties and rent out apartments on Krent.",
    icon: (
      <svg
        width="20"
        height="21"
        viewBox="0 0 20 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.298 12.3077V5.55775L12.048 1.8845L6.798 5.55775V7.65375H5.298V4.81725L12.048 0L18.798 4.81725V12.3077H17.298ZM12.596 6.14425H13.5V5.24025H12.596V6.14425ZM10.596 6.14425H11.5V5.24025H10.596V6.14425ZM12.596 8.14425H13.5V7.24025H12.596V8.14425ZM10.596 8.14425H11.5V7.24025H10.596V8.14425ZM5 16.5L12.2575 18.5537L18.2268 16.7037C18.1756 16.4769 18.0698 16.3029 17.9095 16.1818C17.7492 16.0606 17.5677 16 17.3652 16H12.468C12.0317 16 11.6609 15.9833 11.3558 15.95C11.0506 15.9167 10.7371 15.8436 10.4152 15.7308L8.15775 14.9845L8.60175 13.5153L10.6267 14.2193C10.9294 14.3218 11.2788 14.3916 11.675 14.4288C12.0712 14.4659 12.6346 14.4897 13.3652 14.5C13.3652 14.2525 13.3095 14.039 13.198 13.8595C13.0865 13.68 12.9397 13.5588 12.7575 13.496L6.95575 11.3652C6.93642 11.3589 6.91875 11.3542 6.90275 11.351C6.88675 11.3477 6.86917 11.346 6.85 11.346H5V16.5ZM0 19.423V9.84625H6.8385C6.9435 9.84625 7.04983 9.85775 7.1575 9.88075C7.26533 9.90392 7.36533 9.93083 7.4575 9.9615L13.2845 12.1077C13.7383 12.2756 14.1152 12.5727 14.4152 12.999C14.7153 13.4253 14.8652 13.9257 14.8652 14.5H17.3652C18.0833 14.5 18.6682 14.7318 19.12 15.1953C19.572 15.6586 19.798 16.2602 19.798 17V17.8075L12.3075 20.1345L5 18.05V19.423H0ZM1.5 17.923H3.5V11.346H1.5V17.923Z"
          fill="#056C57"
        />
      </svg>
    ),
  },
  // {
  //   id: "developer",
  //   label: "Developer",
  //   description:
  //     "I'm looking to develop new properties and manage real estate projects on Krent.",
  //   icon: (
  //     <svg
  //       width="16"
  //       height="19"
  //       viewBox="0 0 16 19"
  //       fill="none"
  //       xmlns="http://www.w3.org/2000/svg"
  //     >
  //       <path
  //         d="M0 18.827V5.327H5.23075V2.69225L7.98075 0L10.7308 2.69225V9.327H15.9615V18.827H0ZM1.5 17.327H4V14.827H1.5V17.327ZM1.5 13.327H4V10.827H1.5V13.327ZM1.5 9.327H4V6.827H1.5V9.327ZM6.73075 17.327H9.23075V14.827H6.73075V17.327ZM6.73075 13.327H9.23075V10.827H6.73075V13.327ZM6.73075 9.327H9.23075V6.827H6.73075V9.327ZM6.73075 5.327H9.23075V2.827H6.73075V5.327ZM11.9615 17.327H14.4615V14.827H11.9615V17.327ZM11.9615 13.327H14.4615V10.827H11.9615V13.327Z"
  //         fill="#056C57"
  //       />
  //     </svg>
  //   ),
  // },
];
